import * as GEN from "../../util/gen-dashboard-constants";
export * from "../../util/gen-dashboard-constants";

export const DEFAULT_PAGE_NUMBER_APOLLO = GEN.DEFAULT_PAGE_NUMBER_DASHBOARD;
export const DEFAULT_PAGE_SIZE_APOLLO = GEN.DEFAULT_PAGE_SIZE_DASHBOARD;
export const DEFAULT_SORT_BY_APOLLO = GEN.DEFAULT_SORT_BY_DASHBOARD;
export const DEFAULT_SORT_DIR_APOLLO = GEN.DEFAULT_SORT_DIR_DASHBOARD;
export const DEFAULT_SEARCH_APOLLO = GEN.DEFAULT_SEARCH_DASHBOARD;
